//import message from "./message";

export default class SearchListing {
    constructor(gd) {
        this.grid = gd;
        this.type = $('#campaign_cause');
        this.sortBy = $('#sort_by');
        this.keywords = $('#keywords');
        this.sendIcon = $('#campaign_search + .icon-send');
        this.$listGrid = this.grid.find('.courts--items');
        this.loadMoreBtn = this.grid.find('.load--more');
        this.searchIcon = $('.search-wrap .icon-Search');
        this.searchInput = $('.search-wrap input');
        this.gridIcon = $('.icon-grid');
        this.bindEvents();
    }

    bindEvents = () => {
        this.$page = 1;
        this.type.on('change', this.delayLoad);
        this.sortBy.on('change', this.delayLoad);
        this.keywords.on('keyup', this.search);
        this.sendIcon.on('click', this.delayLoad);
        this.loadMoreBtn.on('click', this.nextPage);

        this.handleSearch();
        this.handlegridChange();
    };

    handleSearch = () => {
        this.searchIcon.on('click', () => {
            this.searchInput.toggleClass('inpt-width');
        });
    };

    handlegridChange = () => {
        this.gridIcon.on('click', () => {
            $('.campaign--items > div').toggleClass('col-md-6 col-md-4');
        });
    };

    search = (e) => {
        if (e.keyCode === 13) {
            this.delayLoad();
        }
    };
    delayLoad = () => {
        this.resetPage();
        this.$listGrid.empty();
        this.showLoader();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.filterCampaign, 1000);
    };
    nextPage = () => {
        this.addPage();
        this.showLoader();
        this.loadMore();
    };
    loadMore = () => {
        $.ajax({
            dataType: 'html',
            type: 'GET',
            data: {
                page: this.$page,
                keywords: this.getKeywords(),
                type: this.getType(),
                activeTab: this.getCurrentTab(),
                sort_by: this.getSortBy(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.appendItems
        });
    };
    appendItems = (data) => {
        if (data) {
            let $data = $(data);
            this.hideLoader();
            this.getCurrentGrid().append($data);
        } else {
            this.loadMoreBtn.addClass('hidden');
            this.hideLoader();
        }
    };
    filterCampaign = () => {
        $.ajax({
            dataType: 'html',
            type: 'GET',
            data: {
                page: this.$page,
                keywords: this.getKeywords(),
                getType: this.getType(),
                activeTab: this.getCurrentTab(),
                sort_by: this.getSortBy(),
                isAjax: true
            },
            url: this.getCurrentPagePath(),
            success: this.applyFilters
        });
        this.addPage();
    };
    applyFilters = (response) => {
        let data;
        if (this.grid.length) {
            if (!response) {
                data = `<div class="text-center not-found"><h2>No Results found</h2></div>`;
                this.loadFlag = true;
            } else {
                data = $(response);
                this.loadFlag = false;
            }
            this.loadFlag ? this.loadMoreBtn.addClass('hidden') : this.loadMoreBtn.removeClass('hidden');
            this.hideLoader();
            this.getCurrentGrid().empty();
            this.getCurrentGrid().append(data);
        }
    };
    hideLoader = () => {
        this.loadMoreBtn.text(this.loadMoreBtn.data('text'));
    };
    showLoader = () => {
        this.loadMoreBtn.text( this.loadMoreBtn.data('loading-text'));
    };
    addPage = () => {
        this.$page += 1;
    };
    resetPage = () => {
        this.$page = 1;
    };
    getKeywords = () => {
        return this.keywords.val() ? encodeURI(this.keywords.val()) : '';
    };
    getType = () => {
        return this.type.val() ? encodeURI(this.type.val()) : '';
    };
    getCurrentTab = () => {
        let activeTab = $('.tab--type.active').attr('data-name');
        return activeTab ? encodeURI(activeTab) : '';
    };
    getCurrentGrid = () => {
        return $('.search--grid.active');
    };
    getSortBy = () => {
        return this.sortBy.val() ? encodeURI(this.sortBy.val()) : '';
    };

    getCurrentPagePath = () => {
        return location.href.split('?')[0];
        //return location.href;
    };

}